const TERMINAL_STATUSES = {
  completed: 'completed',
  returned_to_sender: 'returned_to_sender'
}

export default {
  TERMINAL_STATUSES
}
